import { memo } from 'react';

import TableFieldIconSVG from '@/assets/field-type-table.svg?react';
import { Icon, IconProps } from '@/components/core';

const ITableFieldIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={TableFieldIconSVG} {...props} />
);

export const TableFieldIcon = memo(ITableFieldIcon) as typeof ITableFieldIcon;
